import styled from 'styled-components';

export const ContainerStyle = styled.div`
margin-bottom: 50px
`;
